import { FilterInput, SortInput, SupportedSortBy } from '@apeiron/common'
import { FavoriteFilter } from '@src/types/favoriteFilter'
import * as yup from 'yup'

// TODO - remove 'any' on schema
export const favoriteFilterSchema: yup.SchemaOf<
  FavoriteFilter<FilterInput> | any
> = yup
  .object({
    id: yup.string().default(''),
    name: yup.string().default(''),
    filterInput: yup.object().transform((_: string, originalValue: string) => {
      return JSON.parse(originalValue) as FilterInput
    }),
    sortInput: yup.object().transform((_: string, originalValue: string) => {
      return JSON.parse(originalValue) as SortInput<SupportedSortBy>
    })
  })
  .from('ID', 'id')
  .from('filterOption', 'filterInput')
  .from('sortOption', 'sortInput')

export const removeFavoriteFilterSchema = yup.boolean().required()
